import React from 'react';
import {Text} from '@cloudaper/react';

const AppHeader = () => {
  return (
    <div className="appHeader">
      <Text className="appHeading">Document Manager</Text>
    </div>
  );
};

export default AppHeader;
